import { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { usePermission } from '../../hooks';

interface AuthorizationRouteWrapperProps extends PropsWithChildren {
    requiredPermission: string;
}
export const AuthorizationRouteWrapper: FC<AuthorizationRouteWrapperProps> = ({
    children,
    requiredPermission,
}) => {
    const { hasPermission } = usePermission(requiredPermission);

    const location = useLocation();

    if (location.pathname === '/home') {
        return children;
    }

    if (hasPermission) {
        return children;
    }

    if (!requiredPermission) {
        return children;
    }

    return <Navigate to={'/'} />;
};

export const AuthorizationComponentWrapper: FC<
    AuthorizationSidebarWrapperProps
> = ({ children, requiredPermission }) => {
    const { hasPermission } = usePermission(requiredPermission);

    if (hasPermission) {
        return children;
    }

    return null;
};

interface AuthorizationSidebarWrapperProps extends PropsWithChildren {
    requiredPermission: string | string[];
}
export const AuthorizationSidebarWrapper: FC<
    AuthorizationSidebarWrapperProps
> = ({ children, requiredPermission }) => {
    const { hasPermission } = usePermission(requiredPermission);

    if (hasPermission) {
        return children;
    }

    return null;
};
